// Ticketmaster affiliate configuration (Impact "US & Canada" program)
const TICKETMASTER_CONFIG = {
  mediaPartnerId: "4727849",
  campaignId: "4272",
  adId: "264167",
  trackingDomain: "ticketmaster.evyy.net",
} as const;

// TicketWeb is a Ticketmaster site, so the same campaign deep-links to it
const TICKETMASTER_DOMAINS = [
  "ticketmaster.com",
  "ticketmaster.ca",
  "ticketweb.com",
  "ticketweb.ca",
] as const;

export function isTicketmasterUrl(url: string): boolean {
  try {
    const { protocol, hostname } = new URL(url);
    if (protocol !== "https:" && protocol !== "http:") return false;
    const host = hostname.toLowerCase();
    return TICKETMASTER_DOMAINS.some(
      (domain) => host === domain || host.endsWith(`.${domain}`)
    );
  } catch {
    return false;
  }
}

/**
 * The Discovery API returns event urls already wrapped in our Impact link, even for
 * promoter-sold events. Impact only redirects to Ticketmaster sites and shows
 * "The link you clicked on is malformed" otherwise, so those go straight to the promoter.
 */
export function unwrapOffTicketmasterAffiliateUrl(url: string): string {
  try {
    const { hostname, searchParams } = new URL(url);
    if (hostname.toLowerCase() !== TICKETMASTER_CONFIG.trackingDomain) {
      return url;
    }
    const destination = searchParams.get("u");
    if (!destination || isTicketmasterUrl(destination)) return url;
    const { protocol } = new URL(destination);
    return protocol === "https:" || protocol === "http:" ? destination : url;
  } catch {
    return url;
  }
}

export function convertToAffiliate(
  originalUrl: string,
  options: {
    src?: string;
    distinctId?: string;
  } = {}
): string {
  if (!isTicketmasterUrl(originalUrl)) {
    return originalUrl;
  }
  const { src = "punchup", distinctId } = options;

  const baseUrl = `https://${TICKETMASTER_CONFIG.trackingDomain}/c/${TICKETMASTER_CONFIG.mediaPartnerId}/${TICKETMASTER_CONFIG.adId}/${TICKETMASTER_CONFIG.campaignId}`;
  const params = new URLSearchParams();

  params.set("u", encodeURIComponent(originalUrl));
  params.set("subId1", src);

  if (distinctId) {
    params.set("subId2", distinctId);
  }

  const affiliateUrl = `${baseUrl}?${params.toString()}`;
  return affiliateUrl;
}
